var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("文章管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTabAdd" },
          [
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("el-page-header", {
                      attrs: { content: _vm.title },
                      on: { back: _vm.goBack },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      "label-position": "right",
                      model: _vm.ruleForm1,
                      rules: _vm.rules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "标题", prop: "name" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入标题" },
                          model: {
                            value: _vm.ruleForm1.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "name", $$v)
                            },
                            expression: "ruleForm1.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "类型", prop: "type" } },
                      [
                        _c("el-cascader", {
                          staticStyle: { "margin-right": "auto" },
                          attrs: {
                            props: _vm.cateProps,
                            "show-all-levels": false,
                            options: _vm.cageryList,
                          },
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.ruleForm1.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "type", $$v)
                            },
                            expression: "ruleForm1.type",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "上传图片", prop: "img" } },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "avatar-uploader",
                            staticStyle: { "margin-right": "auto" },
                            attrs: {
                              "list-type": "picture-card",
                              action: _vm.uploadUrl,
                              headers: _vm.deader,
                              "on-success": _vm.handleAvatarSuccess,
                              "on-remove": _vm.handleRemove,
                              multiple: true,
                              "file-list": _vm.ruleForm1.img,
                              limit: 1,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-plus avatar-uploader-icon",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "短简介", prop: "memo" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            placeholder: "请输入短简介",
                          },
                          model: {
                            value: _vm.ruleForm1.memo,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "memo", $$v)
                            },
                            expression: "ruleForm1.memo",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "简介", prop: "memo1" } },
                      [
                        _c("el-upload", {
                          staticClass: "avatar-uploader-quiil",
                          attrs: {
                            action: _vm.uploadUrl,
                            headers: _vm.deader,
                            "show-file-list": false,
                            "on-success": _vm.uploadSuccess1,
                            "on-error": _vm.uploadError,
                            "before-upload": _vm.beforeUpload,
                          },
                        }),
                        _vm._v(" "),
                        _c("quill-editor", {
                          ref: "myQuillEditor",
                          attrs: { options: _vm.editorOption },
                          on: {
                            blur: function ($event) {
                              return _vm.onEditorBlur($event)
                            },
                            focus: function ($event) {
                              return _vm.onEditorFocus($event)
                            },
                            change: function ($event) {
                              return _vm.onEditorChange($event)
                            },
                            ready: function ($event) {
                              return _vm.onEditorReady($event)
                            },
                          },
                          model: {
                            value: _vm.ruleForm1.memo1,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "memo1", $$v)
                            },
                            expression: "ruleForm1.memo1",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { staticStyle: { "margin-top": "190px" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "50px" },
                            on: {
                              click: function ($event) {
                                return _vm.resetForm1("ruleForm")
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v("确定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }